module.exports = __webpack_public_path__ + "media/glycolic-medium.16bb1efd.mp4";